// extracted by mini-css-extract-plugin
export default {"Wrapper":"MessagesNotification_Wrapper__SeV5i","Dot":"MessagesNotification_Dot__8Supc"};